export const SET_CART_COUNT = 'SET_CART_COUNT';
export const SET_WISHLIST_COUNT = 'SET_WISHLIST_COUNT';